import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Empty } from 'antd';

const DistributionByHourChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Empty description="Nenhum dado encontrado" />;
  }

  // Formatar hora para exibição
  const chartData = data.map(item => ({
    ...item,
    hourFormatted: `${item.hour}h`
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="hourFormatted" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`${value} lotes`, 'Total']}
          labelFormatter={(label) => `Horário: ${label}`}
        />
        <Legend />
        <Bar dataKey="totalBatches" name="Lotes" fill="#fa8c16" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DistributionByHourChart;

